import React from 'react';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import Rent from './Rent';

function RentIndex() {
  return (
    <div>
      <Navbar />
      <Rent />
      <Footer />
    </div>
  );
}

export default RentIndex;
